import React, { type ReactElement } from 'react'
import SectionHeading from '../../../../shared/components/ui/headings/SectionHeading'
import { APP_VIRTUAL_TERMINAL_PATH } from '../../../../pages/app/virtual-terminal'
import { APP_TRANSACTIONS_PATH } from '../../../../pages/app/transactions'
import TransactionsIcon from '../../../../shared/components/ui/icons/TransactionsIcon'
import GenericCreditCardIcon from '../../../../shared/components/ui/icons/GenericCreditCardIcon'
import { APP_RECURRING_PAYMENTS_PATH } from '../../../../pages/app/recurring-charges'
import RecurringPaymentsIcon from '../../../../shared/components/ui/icons/RecurringPaymentsIcon'
import { QuickLinksCard } from './components/QuickLinksCard'

export function QuickLinksSection (): ReactElement {
  return (
    <>
      <SectionHeading text="Quick Links" />
      <div className="flex justify-around w-full">
        <QuickLinksCard
          title="Virtual Terminal"
          subtitle="Process credit card payments."
          icon={<GenericCreditCardIcon />}
          buttonPath={APP_VIRTUAL_TERMINAL_PATH}
          buttonText="Enter Payments"
        />
        <QuickLinksCard
          title="Transactions"
          subtitle="View and manage new and previous transactions."
          icon={<TransactionsIcon />}
          buttonPath={APP_TRANSACTIONS_PATH}
          buttonText="View Your Activity"
        />
        <QuickLinksCard
          buttonPath={APP_RECURRING_PAYMENTS_PATH}
          buttonText="Manage Recurring Charges"
          icon={<RecurringPaymentsIcon />}
          subtitle="Add, adjust and update recurring charges"
          title="Recurring Charges"
        />
      </div>
    </>
  )
}
